"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SofiaFontFace = void 0;
const React = __importStar(require("react"));
const namesToWeights = {
    ultralight: 100,
    extralight: 200,
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    black: 900,
};
const SofiaFontFace = ({ prefix = '/assets/fonts/sofia', }) => {
    const acc = [];
    for (const weight of Object.keys(namesToWeights)) {
        for (const italic of [false, true]) {
            const italicPrefix = italic ? '-italic' : '';
            acc.push(`
@font-face {
  font-family: "sofia-pro";
  src: url('${prefix}/${weight}${italicPrefix}/font.woff') format('woff'),
       url('${prefix}/${weight}${italicPrefix}/font2.woff') format('woff2');
  font-weight: ${namesToWeights[weight]};
  font-display: block;
  font-style: ${italic ? 'italic' : 'normal'};
}
      `);
        }
    }
    return React.createElement("style", null, `${acc.join('\n')}`);
};
exports.SofiaFontFace = SofiaFontFace;
//# sourceMappingURL=fonts.js.map